import { registerTheme } from 'echarts/core';

let themeRegistered = false;

export const CUSTOMER_PORTAL_ECHARTS_THEME = 'customer-portal';

export function registerCustomerPortalEchartsTheme(): void {
  if (themeRegistered || typeof document === 'undefined' || !document.body) {
    return;
  }

  const raw = getComputedStyle(document.body)
    .getPropertyValue('--font-family-primary')
    .trim()
    .replace(/['"]/g, '');

  const fontFamily = raw.length > 0 ? raw : 'Nunito Sans, sans-serif';

  registerTheme(CUSTOMER_PORTAL_ECHARTS_THEME, {
    color: ['#2563eb', '#16a34a', '#f59e0b', '#dc2626', '#7c3aed', '#0891b2'],
    textStyle: { fontFamily },
    title: { textStyle: { fontFamily } },
    legend: { textStyle: { fontFamily } },
    tooltip: { textStyle: { fontFamily } },
    categoryAxis: {
      axisLabel: { fontFamily },
      axisName: { fontFamily },
    },
    valueAxis: {
      axisLabel: { fontFamily },
      axisName: { fontFamily },
    },
  });
  themeRegistered = true;
}
